export const ensureValidEth = (val) => {
  if (!val.length) return "0";
  if (val.indexOf(".") === -1) return val;
  const sides = val.split(".");
  if (sides[1].length === 0) sides[1] = "";
  return `${sides[0]}.${sides[1].slice(0, 18)}`;
};
